import { render } from "./SeguimientoOrden.vue?vue&type=template&id=e0873a32&scoped=true"
import script from "./SeguimientoOrden.vue?vue&type=script&lang=js"
export * from "./SeguimientoOrden.vue?vue&type=script&lang=js"

import "./SeguimientoOrden.vue?vue&type=style&index=0&id=e0873a32&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0873a32"]])

export default __exports__